export default "__VITE_ASSET__N1GZca3y__"